import { Route, Routes, Navigate } from "react-router-dom";
import Orders from "./pages/orders";
import Users from "./pages/users";
import Customers from "./pages/customers";
import Settings from "./pages/settings";

import Login from "./pages/login";
import { useCallback, useEffect, useState } from "react";
import FaleAPI from "fale";
import Onboard from "./pages/onboard";
import Welcome from "./pages/welcome";
import Dishes from "./pages/dishes";
import FAQ from "./pages/faq";
import Payments from "./pages/payments";

function App() {
  const [currentUser, setCurrentUser] = useState(null);
  const [kitchens, setKitchens] = useState([]);
  const [selectedKitchen, setSelectedKitchen] = useState(null);

  const token = localStorage.getItem("sessionToken");
  const fetchCurrentUser = useCallback(() => {
    if (localStorage.getItem("sessionToken")) {
      FaleAPI.users.getCurrent().then((user) => {
        if (user.statusCode) return;

        setCurrentUser(user);

        const data = user.userRoles.reduce(
          (ks, role) => [...ks, role.kitchen],
          []
        );
        setKitchens(data);
        if (!selectedKitchen) {
          setSelectedKitchen(data.length ? data[0] : null);
        }
      });
    } else if (!["/login", "/onboard"].includes(window.location.pathname)) {
      window.location.href = "/login";
    }
  }, [selectedKitchen]);

  useEffect(() => {
    fetchCurrentUser();
  }, [token, fetchCurrentUser]);

  const pageProps = {
    kitchens,
    selectedKitchen,
    setSelectedKitchen,
    currentUser,
    refetchCurrentUser: fetchCurrentUser,
  };

  return (
    <Routes>
      <Route path="/" element={<Navigate replace to="/welcome" />} />
      <Route path="/login" element={<Login />} />
      <Route path="/onboard" element={<Onboard />} />
      <Route path="/welcome" element={<Welcome {...pageProps} />} />
      <Route path="/faq" element={<FAQ {...pageProps} />} />
      <Route path="/payments" element={<Payments {...pageProps} />} />
      <Route path="/orders" element={<Orders {...pageProps} />} />
      <Route path="/dishes" element={<Dishes {...pageProps} />} />
      <Route path="/users" element={<Users {...pageProps} />} />
      <Route path="/customers" element={<Customers {...pageProps} />} />
      <Route path="/settings" element={<Settings {...pageProps} />} />
    </Routes>
  );
}

export default App;
